import { Injectable } from '@angular/core';
import moment from 'moment';
import { DriverTask } from '../classes/driver-task';
import { OutboundAircraftAddEvent } from '../classes/outbound-aircraft-add-event';
import { Passenger } from '../classes/passenger';
import { VanEventAddEvent } from '../classes/vanEvent-addEvent';
import { Roles } from '../common/roles';
import { TaskType } from '../common/task-types';
import { TransportStatus } from '../common/transport-status';
import { RolesService } from './roles.service';

@Injectable({
  providedIn: 'root'
})
export class MapPopUpService {
  constructor(private rolesService: RolesService) { }


  makeVanPopup(data: VanEventAddEvent): string {


    if(data.taskType === 'Remote Parking' || data.taskType === 'Terminal' || data.taskType === 'AdHoc' || !data.taskType){
      return `` +
      `<div class="cvv-flex-row">
        <div style="font-size:15px">${ data.driverName.toLocaleUpperCase()}</div>
      </div>
      <div class="cvv-flex-row">
        <div>Van:</div>
        <div>${ data.vanName}</div>
      </div>
      <div class="cvv-flex-row">
        <div>Task:</div>
        <div>${data.taskType === null && data.vanStatus === 'ACTIVE' ? 'Terminal' : data.taskType || ''}</div>
      </div>`
    }else{
    return `` +
      `<div class="cvv-flex-row">
        <div style="font-size:15px">${ data.driverName.toLocaleUpperCase()}</div>
      </div>
      <div class="cvv-flex-row">
        <div>Van:</div>
        <div>${ data.vanName}</div>
      </div>
      <div class="cvv-flex-row">
        <div>Task:</div>
        <div>${ data.taskType}</div>
      </div>
      <div class="cvv-flex-row">
        <div>Flight:</div>
        <div>${ data.flightNumber}</div>
      </div>
      <div class="cvv-flex-row">
        <div>Segment:</div>
        <div>${ data.flightOrigin}-${ data.flightDest}</div>
      </div>
      <div class="cvv-flex-row">
        <div>Ramp:</div>
        <div>${ data.parkingPosition}</div>
      </div>`
    }

  }


  makeOutboundAircraftMarkerPopup(data: OutboundAircraftAddEvent): string {
    let passList = '';
    let om_passTbl = '';
    // Safely handle departureTime - it may be null, undefined, or not a string
    const departureTimeHHMM = (typeof data.departureTime === 'string' && data.departureTime.length >= 16) 
      ? data.departureTime.substring(11, 16) 
      : '';

    if(data.passengers && data.passengers.length){
      passList = this.makePassengerTable(data.passengers);
      om_passTbl = `` +
      `<table class="table table-condensed table-bordered">
        <tbody>
          <tr><td colspan="3" height="25" class="popview-table-header"><strong>Drop-Off Status</strong></td></tr>
          ${passList}
        </tbody>
      </table>`
    }

    return `` +
    `<div class="popView">
      <table class="table table-condensed table-bordered" style="min-width:100px;">
      <tbody>
          <tr><td colspan="2" class="popview-table-header"><strong>Outbound Flight <i class="fa icon-airplane-popup-small-inline rotateOutbound" aria-hidden="true"></i></strong></td></tr>
          <tr><td>${data.flightNumber}</td><td>${data.parkingPosition}</td></tr>
          <tr><td>${data.tailNumber}</td><td>${data.destination}</td></tr>
          <tr><td colspan="2">ETD: ${departureTimeHHMM}</td></tr>
        </tbody>
      </table>
      ${om_passTbl}
    </div>`
  }




  makePassengerTable(om_passengersArray: Passenger[]): string{
    let passList = '';
    om_passengersArray.forEach((row: Passenger) => {
      const omp_checkedIn     = row.checkedIn;
      const omp_firstName     = row.firstName;
      const omp_lastName      = row.lastName;
      const omp_role          = row.role;
      const omp_passengerTransportStatus = row.passengerTransportStatus;
      const omp_formattedName = omp_firstName.charAt(0)+'. '+omp_lastName || omp_lastName || '';
      let statusColor = !omp_checkedIn ? 'red' : 'gray';
      switch(omp_passengerTransportStatus){
        case TransportStatus.NOT_PICKED_UP : statusColor = 'red';    break;
        case TransportStatus.DROPPED_OFF   : statusColor = 'green';  break;
        case TransportStatus.PICKED_UP     : statusColor = 'orange'; break;
      }
      const passCheckedInIcon = '<i class="css-circle-pass-checked-in" style="background-color:' + statusColor + '"></i>';
      const passRow = '<tr><td style="text-align:center">'+passCheckedInIcon+'</td><td style="padding-right:10px;">'+omp_role+'</td><td>'+omp_formattedName+'</td></tr>';
      passList += passRow;
    })
    return passList;
  }


  makeUnassignedTaskPopup(unassignedTask: DriverTask): string{
    let assignTaskButton = '';
    const arrivalTime = moment(unassignedTask.arrivalTime).format("HH:mm") || '';
    const plannedCompleteTime = moment(unassignedTask.plannedEnd).format("HH:mm") || '';
    const estTimeRow = unassignedTask.typeName === TaskType.INBOUND_FLIGHT ? `Sched Arr: <strong>${arrivalTime}</strong>` : `Due Time: <strong>${plannedCompleteTime}</strong>` || '';
    const display_parking = unassignedTask.typeName === TaskType.TERMINAL ? 'Terminal' : unassignedTask.parkingPosition;
    const gtwyLabel = this.makeGtwyLabel(unassignedTask);

    if (this.rolesService.roles$.getValue().includes(Roles.COORDINATOR) ||
        this.rolesService.roles$.getValue().includes(Roles.DRIVER)) {
          assignTaskButton = `<tr><td colspan="2" style="text-align:center"><button id="buttonAssignTaskFromMarker_${unassignedTask.taskName}" class="btn btn-info buttonAssignTaskFromMarker">Assign Task <span class="icon-new-task-button-icon-white"></span></button></td></tr>`;
    }

    return `<div class="popView"><table class="table table-condensed table-bordered"><tbody>
      <tr><td colspan="2" class="popview-table-header"><strong>Unassigned Task</strong></td></tr>
      <tr><td>${unassignedTask.displayName}</td><td>${unassignedTask.tailNumber}</td></tr>
      <tr><td>${display_parking}</td><td>${gtwyLabel}</td></tr>
      <tr><td colspan="2">${estTimeRow}</td></tr>
      <tr><td colspan="2">${unassignedTask.passengers.length} Passengers<br></td></tr>
      ${assignTaskButton}
    </tbody></table></div>`;

  }


  makeGtwyLabel(unassignedTask: DriverTask): string{
    const airplaneStatusText = this.makeAirplaneStatusText(unassignedTask);
    switch (unassignedTask.typeName) {
			case TaskType.INBOUND_FLIGHT:
				return `${unassignedTask.origin} <i class="icon-airplane-popup-small-inline rotateInbound" aria-hidden="true"></i> ${airplaneStatusText}`;
			case TaskType.OUTBOUND_FLIGHT:
				return `${unassignedTask.destination} <i class="icon-airplane-popup-small-inline rotateOutbound" aria-hidden="true"></i>`;
      default:
        return '';
    }
  }

  makeAirplaneStatusText(unassignedTask: DriverTask): string{
		let airplaneStatusText = '';
    const inTime = unassignedTask.actualInTime;
    const onTime = unassignedTask.actualOnTime;
		if (onTime != "--" && onTime !== null && typeof onTime !== 'undefined') { // we have a valid actual on time
			airplaneStatusText = '(ON)';
		}
		if (inTime != "--" && inTime !== null && typeof inTime !== 'undefined') {
			airplaneStatusText = '(IN)';
		}
    return airplaneStatusText;
  }




  makeDriverTaskPopup(driverTask: DriverTask): string {
    let minutesUntilDueForMarker = this.timeMathForMarker(driverTask.plannedEnd) || '';
    return '<div class="popView"><strong>Current Task<br>'+driverTask.displayName+'</strong><br>'+minutesUntilDueForMarker+'</div>';
  }

  timeMathForMarker(thisDate) {
    var then = thisDate;
    var dueIn = moment(then).fromNow(false); // <-- magic
    return 'Due ' + dueIn;
  }




}
